import React from 'react';
import ZenoIdle from '../../components/ui/ZenoIdle';

// Cinta de luz al pie del sidebar, con Zeno encima. No es un bloque de color:
// es una hoja translucida que nace del borde izquierdo y se desvanece hacia
// arriba a la derecha, con un canto brillante y un resplandor debajo, para
// que se funda con el fondo oscuro de la barra.
export default function SidebarSilk() {
  return (
    <div className="pointer-events-none relative -mx-6 -mb-6 mt-auto h-[220px] select-none overflow-hidden" aria-hidden>
      <svg className="absolute inset-0 h-full w-full" viewBox="0 0 272 220" preserveAspectRatio="none">
        <defs>
          <radialGradient id="silkUnder" cx="0.12" cy="0.95" r="0.85">
            <stop offset="0" stopColor="#a855f7" stopOpacity="0.55" />
            <stop offset="0.55" stopColor="#7c3aed" stopOpacity="0.16" />
            <stop offset="1" stopColor="#7c3aed" stopOpacity="0" />
          </radialGradient>
          <linearGradient id="silkSheet" x1="0" y1="1" x2="1" y2="0">
            <stop offset="0" stopColor="#c084fc" stopOpacity="0.8" />
            <stop offset="0.5" stopColor="#7c3aed" stopOpacity="0.42" />
            <stop offset="1" stopColor="#6d28d9" stopOpacity="0" />
          </linearGradient>
          <linearGradient id="silkEdge" x1="0" y1="0" x2="1" y2="0">
            <stop offset="0" stopColor="#f5d0fe" stopOpacity="1" />
            <stop offset="0.5" stopColor="#c4b5fd" stopOpacity="0.85" />
            <stop offset="1" stopColor="#a78bfa" stopOpacity="0" />
          </linearGradient>
          <filter id="silkSoft" x="-20%" y="-30%" width="140%" height="160%">
            <feGaussianBlur stdDeviation="9" />
          </filter>
          <filter id="silkGlow" x="-20%" y="-60%" width="140%" height="220%">
            <feGaussianBlur stdDeviation="3.2" />
          </filter>
        </defs>

        <rect width="272" height="220" fill="url(#silkUnder)" />

        {/* Hoja translucida: difusa detras, mas definida encima */}
        <path
          d="M0 108 C48 100 96 122 146 132 C196 142 240 122 272 98 L272 -10 C220 34 170 72 116 84 C64 94 26 84 0 62 Z"
          fill="url(#silkSheet)"
          filter="url(#silkSoft)"
        />
        <path
          d="M0 108 C48 100 96 122 146 132 C196 142 240 122 272 98 L272 8 C222 44 172 82 118 92 C66 102 28 92 0 72 Z"
          fill="url(#silkSheet)"
          fillOpacity="0.55"
        />
        {/* Pliegue fino dentro de la hoja */}
        <path
          d="M0 88 C40 96 86 110 134 106 C192 100 234 70 272 40"
          fill="none"
          stroke="#c4b5fd"
          strokeOpacity="0.3"
          strokeWidth="1"
        />

        {/* Canto brillante: resplandor + linea nitida */}
        <path
          d="M0 108 C48 100 96 122 146 132 C196 142 240 122 272 98"
          fill="none"
          stroke="#c084fc"
          strokeOpacity="0.6"
          strokeWidth="6"
          filter="url(#silkGlow)"
        />
        <path
          d="M0 108 C48 100 96 122 146 132 C196 142 240 122 272 98"
          fill="none"
          stroke="url(#silkEdge)"
          strokeWidth="1.8"
        />
      </svg>

      <div className="absolute bottom-3 left-1/2 -translate-x-1/2">
        <ZenoIdle size={92} />
      </div>
    </div>
  );
}
